document.querySelectorAll('.before-after-slide').forEach(slider => {
  const wrapper = slider.querySelector('.image-after-wrapper');
  const line = slider.querySelector('.slider-line');
  const handle = slider.querySelector('.slider-handle');

  let value = 50;
  let dragging = false;
  let pointerId = null;
  let rect = null;
  let raf = null;

  function render() {
    wrapper.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
    line.style.left = `${value}%`;
    handle.style.left = `${value}%`;
    const rounded = Math.round(value);
    handle.setAttribute('aria-valuenow', String(rounded));
    handle.setAttribute('aria-valuetext', `${rounded}%`);
  }

  function scheduleRender() {
    if (raf) return;

    raf = requestAnimationFrame(() => {
      raf = null;
      render();
    });
  }

  function setValue(next) {
    value = Math.max(0, Math.min(100, next));
    scheduleRender();
  }

  function updatePosition(clientX) {
    let x = clientX - rect.left;
    x = Math.max(0, Math.min(rect.width, x));

    value = (x / rect.width) * 100;

    scheduleRender();
  }

  function onMove(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    updatePosition(e.clientX);
  }

  function onUp(e) {
    if (e.pointerId !== pointerId) return;

    dragging = false;
    pointerId = null;
    rect = null;

    slider.classList.remove('dragging');

    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onUp);
    window.removeEventListener('pointercancel', onUp);
  }

  slider.addEventListener('pointerdown', e => {
    e.preventDefault();

    dragging = true;
    pointerId = e.pointerId;
    rect = slider.getBoundingClientRect();

    slider.classList.add('dragging');

    updatePosition(e.clientX);

    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  });

  handle.addEventListener('keydown', e => {
    let next = value;

    switch (e.key) {
      case 'ArrowLeft':
      case 'ArrowDown':
        next = value - 1;
        break;
      case 'ArrowRight':
      case 'ArrowUp':
        next = value + 1;
        break;
      case 'PageDown':
        next = value - 10;
        break;
      case 'PageUp':
        next = value + 10;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = 100;
        break;
      default:
        return;
    }

    e.preventDefault();
    setValue(next);
  });

  render();
});